const BREAKPOINT_MD = 600;
const BREAKPOINT_LG = 1024;
const BREAKPOINT_XL = 1280;
const BREAKPOINT_2XL = 1600;
const BREAKPOINT_3XL = 1680;

const SIZE_LANDING_PAGE = 1440;

const SIZE_SM = 'sm';
const SIZE_MD = 'md';
const SIZE_LG = 'lg';
const SIZE_XL = 'xl';
const SIZE_2XL = '2xl';
const SIZE_3XL = '3xl';
const LANDING_PAGE = 'landing-page';

let breakpoints = {};
breakpoints[SIZE_MD] = `${BREAKPOINT_MD}px`;
breakpoints[SIZE_LG] = `${BREAKPOINT_LG}px`;
breakpoints[SIZE_XL] = `${BREAKPOINT_XL}px`;
breakpoints[SIZE_2XL] = `${BREAKPOINT_2XL}px`;
breakpoints[SIZE_3XL] = `${BREAKPOINT_3XL}px`;
breakpoints[LANDING_PAGE] = `${SIZE_LANDING_PAGE}px`;

module.exports = {};

module.exports.breakpoints = breakpoints;

module.exports.SIZE_SM = SIZE_SM;
module.exports.SIZE_MD = SIZE_MD;
module.exports.SIZE_LG = SIZE_LG;
module.exports.SIZE_XL = SIZE_XL;
module.exports.SIZE_2XL = SIZE_2XL;
module.exports.SIZE_3XL = SIZE_3XL;
module.exports.LANDING_PAGE = SIZE_LANDING_PAGE;

module.exports.BREAKPOINT_MD = BREAKPOINT_MD;
module.exports.BREAKPOINT_LG = BREAKPOINT_LG;
module.exports.BREAKPOINT_XL = BREAKPOINT_XL;
module.exports.BREAKPOINT_2XL = BREAKPOINT_2XL;
module.exports.BREAKPOINT_3XL = BREAKPOINT_3XL;
module.exports.BREAKPOINT_LANDING_PAGE = SIZE_LANDING_PAGE;
